import type { CampSplitBy } from '../types/camp';

export function inferCampSplitBy(
  instances: Array<{ programId?: string | null; ageGroupId?: string | null }>
): CampSplitBy {
  if (instances.some((i) => i.programId)) return 'program';
  if (instances.some((i) => i.ageGroupId)) return 'age_group';
  return 'none';
}

export function collectCampVariantIds(
  instances: Array<{ programId?: string | null; ageGroupId?: string | null }>,
  splitBy: CampSplitBy
): string[] {
  if (splitBy === 'program') {
    return [...new Set(instances.map((i) => i.programId).filter(Boolean))] as string[];
  }
  if (splitBy === 'age_group') {
    return [...new Set(instances.map((i) => i.ageGroupId).filter(Boolean))] as string[];
  }
  return [];
}

export function formatCampInstanceName(
  baseName: string,
  weekIndex: number,
  variantLabel?: string | null
): string {
  const trimmed = baseName.trim();
  const weekPart = `${trimmed} Week ${weekIndex}`;
  const label = variantLabel?.trim();
  return label ? `${weekPart} - ${label}` : weekPart;
}

export interface CampInstanceMatrixRow {
  weekIndex: number;
  splitId: string | null;
}

export function buildCampInstanceMatrix(input: {
  weeks: number;
  splitBy: CampSplitBy;
  splitIds: string[];
}): CampInstanceMatrixRow[] {
  const rows: CampInstanceMatrixRow[] = [];
  const variants = input.splitBy === 'none' ? [null] : input.splitIds;
  for (let w = 1; w <= input.weeks; w += 1) {
    for (const splitId of variants) {
      rows.push({ weekIndex: w, splitId });
    }
  }
  return rows;
}
